
var sprite = require("/home/jenkins/agent/workspace/rod-authoring-homepage-ui_master/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"Upload-20px\" ><style>#Upload-20px .st0{fill:#959595}</style><path class=\"st0\" d=\"M2 1h16v3H2zm2.5 9.5l1 1 3.8-3.8V20h1.4V7.7l3.8 3.8 1-1L10 5l-5.5 5.5z\"/></symbol>";
module.exports = sprite.add(image, "Upload-20px");


//////////////////
// WEBPACK FOOTER
// ./app/common/icons/Upload-20px.svg
// module id = 44
// module chunks = 0